import { render, staticRenderFns } from "./topic-item.vue?vue&type=template&id=19276684&scoped=true&"
import script from "./topic-item.vue?vue&type=script&lang=js&"
export * from "./topic-item.vue?vue&type=script&lang=js&"
import style0 from "./topic-item.vue?vue&type=style&index=0&id=19276684&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19276684",
  null
  
)

export default component.exports